import { groupBy } from '../../../../../util/arrays/map';
import { wrapWithMaxWidth } from '../../../echarts/util/tooltip';

export default function formatter(datas) {
  const groupedBySeriesName = groupBy(datas, 'seriesName');

  // iterando por conjunto de data de cada seriesName
  const params = Object.keys(groupedBySeriesName)
    .map((seriesName) => {
      const current = groupedBySeriesName[seriesName];

      // exibimos apenas os cujo data != undefined
      const withValue = current
        .filter((item) => item.data);

      // no caso das linhas repetidas, tanto faz exibir um ou outro, os dados são os mesmos.
      return withValue[0];
    })
    .sort((first, second) => second.data.value - first.data.value);

  const pointName = params[0].name;

  const markers = params
    .map((dataItem) => `${dataItem.marker} ${dataItem.seriesName}: ${dataItem.data.value}%`)
    .reduce((reduced, next) => reduced.concat('<br/>').concat(next));

  return wrapWithMaxWidth(`${pointName}<div>${markers}</div>`);
}
